import { Controller } from "stimulus"

export default class extends Controller {
  go(event) {
    const value = event.target.value
    if (value) window.location.href = this.data.get("base-url") + value
  }
}
